import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Inservices from "./pages/Inservices";
import MedicaidAR from "./pages/MedicaidAR";
import SurveyReadiness from "./pages/SurveyReadiness";
import OperationalRisk from "./pages/OperationalRisk";
import LitigationSupport from "./pages/LitigationSupport";
import Speaking from "./pages/Speaking";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/inservices-training" element={<Inservices />} />
          <Route path="/medicaid-ar-recovery" element={<MedicaidAR />} />
          <Route path="/survey-readiness" element={<SurveyReadiness />} />
          <Route path="/operational-risk" element={<OperationalRisk />} />
          <Route path="/litigation-support" element={<LitigationSupport />} />
          <Route path="/speaking-training" element={<Speaking />} />
          <Route path="/knowledge-center" element={<Blog />} />
          <Route path="/knowledge-center/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
